import { render, staticRenderFns } from "./orderCustomer.vue?vue&type=template&id=46a80ca1&scoped=true"
import script from "./orderCustomer.vue?vue&type=script&lang=js"
export * from "./orderCustomer.vue?vue&type=script&lang=js"
import style0 from "./orderCustomer.vue?vue&type=style&index=0&id=46a80ca1&scoped=true&lang=scss"
import style1 from "./orderCustomer.vue?vue&type=style&index=1&id=46a80ca1&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a80ca1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/www/prod-cn-snote-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46a80ca1')) {
      api.createRecord('46a80ca1', component.options)
    } else {
      api.reload('46a80ca1', component.options)
    }
    module.hot.accept("./orderCustomer.vue?vue&type=template&id=46a80ca1&scoped=true", function () {
      api.rerender('46a80ca1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/orderCustomer.vue"
export default component.exports